export const phoneRegexp = /^[-+() \d]*$/;
